<div [formGroup]="learningCenterForm" class="card p-4">
  <h3 style="font-weight: 700; color:#060E9F">เพิ่มวิดีโอ <span style="font-size: 20px; color:#878787; font-weight: 400;">(อัปโหลดได้สูงสุด 5 คลิป)</span></h3>
  <div class="clearfix">
    <nz-upload
      nzListType="picture"
      nzName="video-uploader"
      [nzShowUploadList]="{ showPreviewIcon: true, showRemoveIcon: true, showDownloadIcon: false }"
      [(nzFileList)]="fileList"
      [nzShowButton]="fileList.length < 5"
      [nzPreview]="handlePreview"
      [nzCustomRequest]="handleUpload"
      [nzRemove]="removeFile"
      [nzBeforeUpload]="beforeUpload"
    >
        <button nz-button>
          <span nz-icon nzType="upload"></span>
          อัปโหลด
        </button>
    </nz-upload>
    <nz-modal
      [nzVisible]="previewVisible"
      [nzContent]="modalContent"
      [nzFooter]="null"
      (nzOnCancel)="previewVisible = false"
      [nzWidth]="800"
    >
      <ng-template #modalContent>

        <div class="p-4 d-flex justify-content-center align-items-center">

          <app-video-player [videoId]="previewVideoId"></app-video-player>
        </div>
        <!-- <img [src]="previewImage" [ngStyle]="{ width: '100%' }" /> -->
      </ng-template>
    </nz-modal>
  </div>
</div>
